module.exports = __webpack_public_path__ + "media/images/emblems/Niederried_bei_Interlaken-coat_of_arms-9940ce598e5daf941c7454b459cb20a2.svg";